import {
    Button,
    Container,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PasswordForm from './components/PasswordForm';
import PersonalInformationForm from './components/PersonalInformationForm';
import TwoFactorForm from './components/TwoFactorForm';

const AccountEditView = () => (
    <Container>
        <Segment>
            <SegmentHeader header='Mijn account'>
                <Button onClick={() => window.history.back()}>
                    <ArrowLeftIcon className='size-5' />
                    Terug
                </Button>
            </SegmentHeader>
            <SegmentContent>
                <PersonalInformationForm />
            </SegmentContent>
        </Segment>

        <Segment>
            <SegmentHeader header='Vernieuw wachtwoord' />
            <SegmentContent>
                <PasswordForm />
            </SegmentContent>
        </Segment>

        <Segment>
            <SegmentHeader header='Tweestapsverificatie' />
            <SegmentContent>
                <TwoFactorForm />
            </SegmentContent>
        </Segment>
    </Container>
);

export default AccountEditView;
